import FoldersTable from './FoldersTable'
export default FoldersTable
